export const datafast = 'datafast';
export const leadgods = 'leadgods';
export const niubiz = 'niubiz';
export const pagopluxLink = 'pagoplux_link';
export const pagoplux = 'pagoplux';
export const paymentez = 'paymentez';
export const placetopay = 'placetopay';
export const visa = 'visa';
export const xchange = 'xchange';
export const alignet = 'alignet';
export const mercadopagoMp = 'mercadopagoMp';
export const mercadopago = 'mercadopago';



// WEBPACK FOOTER //
// ./src/shared/enums/gatewayCodes.js